import {
  Box,
  // Button,
  Card,
  Divider,
  Grid,
  Group,
  // Input,
  Menu,
  rem,
  Select,
  Space,
  Text,
} from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const approverData = ["Quang DT", "Chien NX", "Hieu AB"];

const ApprovalInfoCard = () => {
  const { t } = useTranslation();
  const [approver, setApprover] = useState<any>(t("Chien NX"));
  const [authMode, setAuthMode] = useState("1");

  return (
    <Card shadow="sm" radius="md" pb={rem(30)} w="100%">
      <Card.Section inheritPadding py="xs">
        <Group position="apart">
          <Text fz="16px" weight={600}>
            {t("APPROVAL_INFORMATION")}
          </Text>
        </Group>
      </Card.Section>
      <Card.Section inheritPadding py="xs">
        <Grid>
          <Grid.Col span={6}>
            {/* <Text color="#5E656B">{t("BROWSING_ID")}</Text> */}
            <Text fz="14px">{t("APPROVAL_ID")}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text fw={500} ta="right" fz="14px">
              4325325
            </Text>
          </Grid.Col>
        </Grid>
        <Space h="md" />
        <Grid>
          <Grid.Col span={6}>
            {/* <Text color="#5E656B">{t("GRANT_APPROVAL")}</Text> */}
            <Text fz="14px">{t("APPROVAL")}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text fw={500} ta="right" fz="14px">
              1
            </Text>
          </Grid.Col>
        </Grid>
        <Space h="md" />
        <Grid gutter="md">
          <Grid.Col span={6}>
            {/* <Text color="#5E656B">{t("REVIEWER")}</Text> */}
            <Text fz="14px">{t("REVIEWER")}</Text>
          </Grid.Col>

          <Menu shadow="md" width="100%">
            <Menu.Target>
              <Grid.Col
                span="content"
                style={{
                  padding: "10px",
                  marginLeft: "auto",
                  display: "flex",
                }}
              >
                <Text weight={600} color="#0047D0" ta="right" fz="14px">
                  {approver}
                </Text>
                <IconChevronDown color="#0047D0" />
              </Grid.Col>
            </Menu.Target>

            <Menu.Dropdown>
              {approverData.map((item) => {
                return (
                  <Menu.Item
                    key={item}
                    onClick={() => {
                      setApprover(item);
                    }}
                    sx={{
                      background: approver === item ? "#E5F4FE" : "transparent",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Text fz="14px">{item}</Text>
                      </Box>
                    </Box>
                  </Menu.Item>
                );
              })}
            </Menu.Dropdown>
          </Menu>
        </Grid>
      </Card.Section>
      <Divider my="sm" variant="dashed" />
      <Card.Section inheritPadding py="xs">
        <Select
          label={t("AUTHENTICATION_METHOD")}
          styles={{ label: { fontWeight: 600, fontSize: "16px" } }}
          value={authMode}
          onChange={(value) => {
            setAuthMode(value || "1");
          }}
          data={[
            {
              value: "1",
              label: "SMS OTP",
            },
          ]}
          mb="sm"
          name="accountType"
          rightSection={<IconChevronDown size="1rem" />}
        />
        {/* <Input.Wrapper label="OTP" mb="lg">
          <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <Input placeholder={t("CONFIRM_OTP")} sx={{ flex: 1 }} />
            <Button
              sx={{
                borderRadius: "8px",
              }}
              variant="light"
            >
              Get OTP
            </Button>
          </Box>
        </Input.Wrapper> */}
      </Card.Section>
    </Card>
  );
};

export default ApprovalInfoCard;
